export function useSurfaceEditorStoreTemplates() {
  const api = useSurfaceEditorApi();
  const templates = ref(null);
  const templatesDesignProjectType = ref(undefined);

  async function getTemplates({designProjectType} = {}) {
    if (!templates.value || templatesDesignProjectType.value !== designProjectType) {
      templates.value = await api.getTemplates({designProjectType});
      templatesDesignProjectType.value = designProjectType;
    }

    return templates.value;
  }

  async function saveAsTemplate({surface, type = SURFACE_EDITOR_TEMPLATE_TYPES.user, designProjectType}) {
    const template = await api.saveAsTemplate({surface, type, designProjectType});

    templates.value[type].unshift(template);
  }

  async function deleteTemplate({template}) {
    await api.deleteTemplate({template});
    const index = templates.value[template.template_type].findIndex(t => t.id === template.id);
    templates.value[template.template_type].splice(index, 1);
  }

  function clearTemplates() {
    templates.value = null;
    templatesDesignProjectType.value = undefined;
  }

  return {
    templates,
    getTemplates,
    saveAsTemplate,
    deleteTemplate,
    clearTemplates
  };
}
